import React from 'react';
import { Box, Button, Typography, Chip } from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useSuperAdminAuthStore } from '@/store/superAdminAuthStore';
import { PlatformService } from '@/services/platformService';
import { useNavigate } from 'react-router-dom';

export const ImpersonationBanner: React.FC = () => {
  const { impersonation, clearImpersonation } = useSuperAdminAuthStore();
  const navigate = useNavigate();

  if (!impersonation?.isImpersonating) return null;

  const handleExit = async () => {
    try {
      if (impersonation.sessionId) {
        await PlatformService.endImpersonation(impersonation.sessionId);
      }
    } catch (e) {
      console.error('Failed to gracefully end impersonation session:', e);
    } finally {
      clearImpersonation();
      // Remove impersonation tenant header if any
      navigate('/super-admin/societies');
    }
  };

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 9999,
        backgroundColor: '#d97706',
        color: '#ffffff',
        px: { xs: 2, sm: 3 },
        py: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
        flexWrap: 'wrap',
        gap: 1.5,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
        <Chip
          icon={<SupportAgentIcon sx={{ color: '#fff !important' }} />}
          label="SUPPORT MODE"
          size="small"
          sx={{
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            color: '#ffffff',
            fontWeight: 800,
            letterSpacing: 0.5,
          }}
        />
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          You are viewing society:{' '}
          <span style={{ textDecoration: 'underline', fontWeight: 800 }}>
            {impersonation.targetSocietyName || 'Target Society'}
          </span>
        </Typography>
        {impersonation.reason && (
          <Typography
            variant="caption"
            sx={{
              backgroundColor: 'rgba(0,0,0,0.2)',
              px: 1,
              py: 0.25,
              borderRadius: 1,
              fontStyle: 'italic',
            }}
          >
            Reason: {impersonation.reason}
          </Typography>
        )}
      </Box>

      <Button
        variant="contained"
        size="small"
        onClick={handleExit}
        startIcon={<ExitToAppIcon />}
        sx={{
          backgroundColor: '#1e293b',
          color: '#ffffff',
          fontWeight: 700,
          textTransform: 'none',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#0f172a',
          },
        }}
      >
        Exit Support Mode
      </Button>
    </Box>
  );
};
